import help from './help';

let messages = Object.assign({}, help);

export default messages;
